import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import ExpansionsProgressPage from '../../../pages/Cards/ExpansionsProgressPage';
import ExpansionsProgressMobile from '../../../pages/Mobile/Cards/ExpansionsProgressMobile';

const ExpansionsProgressResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <ExpansionsProgressMobile /> : <ExpansionsProgressPage />;
};

export default ExpansionsProgressResponsive;
